import { useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { useDispatch } from "react-redux";
import { SIMPLE_SEARCH } from "../graphql/queries/Search";
import {
  setSearchProductIds,
  setSearchFolderId,
  setSearchFolders,
  setSearchErrors,
  setSearchCalled,
  setSearchLoading,
  setSearchViewSettings,
  setSearchResourceIds,
} from "../actions";

// eslint-disable-next-line import/prefer-default-export
export const useSimpleSearch = () => {
  const dispatch = useDispatch();
  const [getDetailedSearch, { data, loading, error, called }] = useLazyQuery(
    SIMPLE_SEARCH
  );

  useEffect(() => {
    if (data && data.search && data.search.simpleSearch) {
      const { sortedProductIds, sortedResourceIds } = data.search.simpleSearch;
      dispatch(
        setSearchProductIds({
          items: sortedProductIds,
        })
      );

      dispatch(
        setSearchResourceIds({
          items: sortedResourceIds,
        })
      );
      dispatch(setSearchFolderId({ id: null }));
    }

    if (data && data.search && data.search.simpleSearch) {
      const { sites } = data.search.simpleSearch;
      dispatch(
        setSearchFolders({
          folders: sites,
        })
      );
    }

    if (
      data &&
      data.search &&
      data.search.simpleSearch &&
      data.search.simpleSearch.viewSelectorSettings
    ) {
      dispatch(
        setSearchViewSettings({
          settings: data.search.simpleSearch.viewSelectorSettings,
        })
      );
    }
  }, [data]);

  useEffect(() => {
    dispatch(
      setSearchLoading({
        loading,
      })
    );
  }, [loading]);

  useEffect(() => {
    if (error) {
      dispatch(
        setSearchErrors({
          error,
        })
      );
    }
  }, [error]);

  useEffect(() => {
    if (called) {
      dispatch(
        setSearchCalled({
          called,
        })
      );
    }
  }, [called]);

  return { execute: getDetailedSearch, data, loading, error };
};
